<template>
  <c-modal v-model="shouldShow" @onClosed="closeModal" :persistent="true">
    <div class="heading-4 black--text">Reset Password</div>
    <div class="mt-8 text-5 darkgray--text">
      Please set a new secure password.
    </div>
    <ValidationObserver ref="observer">
      <form @submit.prevent="submit">
        <div class="mt-8">
          <div>
            <ValidationProvider
              v-slot="{ errors }"
              name="Password"
              rules="required|min:8|max:64"
              vid="confirmation"
            >
              <v-text-field
                autofocus
                id="password"
                v-model="payload.password"
                :error-messages="errors"
                :append-icon="showPwd ? 'far fa-eye' : 'far fa-eye-slash'"
                :type="showPwd ? 'text' : 'password'"
                @click:append="showPwd = !showPwd"
                outlined
                single-line
                class="c-input"
                placeholder="Password"
                required
                hide-details="auto"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div>
            <ValidationProvider
              v-slot="{ errors }"
              name="Confirm Password"
              rules="required|min:8|max:64|confirmed:confirmation"
            >
              <v-text-field
                id="confirmPassword"
                v-model="payload.confirmPassword"
                :error-messages="errors"
                :append-icon="showCfgPwd ? 'far fa-eye' : 'far fa-eye-slash'"
                :type="showCfgPwd ? 'text' : 'password'"
                @click:append="showCfgPwd = !showCfgPwd"
                outlined
                single-line
                class="c-input mt-3"
                placeholder="Confirm Password"
                required
                hide-details="auto"
              ></v-text-field>
            </ValidationProvider>
          </div>
        </div>
        <div class="mt-8 d-flex justify-end">
          <input type="submit" class="d-none" />
          <c-btn
            @click="submit"
            :loading="resetPasswordState.isSubmitting"
            :disabled="resetPasswordState.isSubmitted"
            >Reset Password</c-btn
          >
        </div>
        <div style="height: 30px" class="mt-3 text-5">
          <div class="error--text" v-if="resetPasswordState.error">
            {{ resetPasswordState.error.message }}
          </div>
          <div
            class="primary--text"
            v-if="
              !resetPasswordState.isSubmitting && resetPasswordState.isSubmitted
            "
          >
            Your password has been updated!
          </div>
        </div>
      </form>
    </ValidationObserver>
  </c-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { required, min, max, confirmed } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty.",
});

extend("min", {
  ...min,
  message: "Please enter 8 to 64 alphanumeric characters or symbols.",
});

extend("max", {
  ...max,
  message: "Please enter 8 to 64 alphanumeric characters or symbols.",
});

extend("confirmed", {
  ...confirmed,
  message: "Passwords don't match.",
});
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    showPwd: false,
    showCfgPwd: false,
    shouldShow: true,
    payload: {
      password: "",
      confirmPassword: "",
    },
  }),
  computed: mapGetters({
    resetPasswordState: "auth/resetPassword",
  }),
  methods: {
    async submit() {
      const isFormValid = await this.$refs.observer.validate();
      if (isFormValid) {
        const token = this.$route.query.token;
        await this.$store.dispatch("auth/resetPassword", {
          password: this.payload.password,
          token,
        });
        if (!this.resetPasswordState.error) {
          setTimeout(() => {
            this.shouldShow = false;
            this.$store.dispatch("showAuthModal", "LogIn");
          }, 1000);
        }
      }
    },
    closeModal() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>